import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const HR: DeepPartial<AddressBook> = {
    trustedContactsAvailable: true,
    contactDetails: {
        fetchAccountName: true,
    },
    templates: {
        transfer: {
            attributes: [
                'senderName',
                'senderReference',
                'symbols',
                'feeSharingCode',
                'individualConditions',
                'repetitionDays',
                'confirmationEmail',
                'additionalInfo',
                'amount',
                'paymentPurpose',
                'hr-paymentSpecifics',
            ],
        },
    },
    prefilling: {
        transfer: [
            'amount',
            'senderName',
            'senderReference',
            'symbols',
            'repetitionDays',
            'additionalInfo',
            'confirmationEmail',
            'paymentPurpose',
            'hr-paymentSpecifics',
            'feeSharingCode',
            'individualConditions',
            'confirmationEmail',
        ],
    },
    abcSelectorButtons: [
        {
            icon: 'security-good',
            i18Key: 'addressbook:filter.trustedContacts',
            matches: 'TRUSTED_CONTACTS',
            alwaysEnabled: true,
        },
        {
            icon: 'star',
            i18Key: 'addressbook:filter.topContacts',
            matches: 'TOP_CONTACTS',
            alwaysEnabled: true,
        },
        {
            key: '123',
            matches: 'OTHER',
        },
        'A',
        'B',
        'C',
        'Č',
        'Ć',
        'D',
        'Đ',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'Š',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'Ž',
    ],
    cacheDuration: {
        contact: 10000,
        template: 10000,
        templates: 10000,
        search: 5000,
    },
};
